import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../Text';
import { dataHooks } from '../constants';
import { classes } from '../Notification.st.css.js';
import { EllipsisCommonProps } from '../../common/PropTypes/EllipsisCommon';
const TextLabel = ({ ellipsis = true, placement = 'bottom', children, ...propsWithNoDefaults }) => (React.createElement("div", { className: classes.label },
    React.createElement(Text, { weight: "normal", ellipsis,
        placement,
        ...propsWithNoDefaults, light: true, dataHook: dataHooks.notificationLabel }, children)));
TextLabel.propTypes = {
    children: PropTypes.node,
    ...EllipsisCommonProps,
};
TextLabel.displayName = 'Notification.TextLabel';
export default TextLabel;
//# sourceMappingURL=index.js.map